import axios from 'axios';
import { objectToQuery } from 'common/helpers/filters.helper';
import {
  ITrackStoreAllStoresCollection,
  ITrackStoreNotificationCollection,
  ITrackStoreNotificationCollectionFilters,
  ITrackStoreOnDutyCollection,
  ITrackStoreOnDutyCollectionFilters,
  ITrackStoreOrderCollectionFilters,
  ITrackStoreOrderCollection,
  ITrackStoreStoreCollection,
  ITrackStoreSummary,
  ITrackStoreSummaryFilters,
  ITrackStoreWeeklyGrid,
  ITrackStoreWeeklyGridFilters,
  ITrackStoreLiveStoresCollection,
  ITrackStoreOrderDetailsFilters,
  ITrackStoreOrderDetails,
} from 'entities/TrackStore/TrackStore.models';

const basePath = '/cir-portal/track-store';

export const trackStoreTransport = {
  getStoreCollection: (): Promise<ITrackStoreStoreCollection> => axios.get(`${basePath}/stores`),
  getSummary: (filters: ITrackStoreSummaryFilters): Promise<ITrackStoreSummary> =>
    axios.get(`${basePath}/summary${objectToQuery(filters)}`),
  getWeeklyGrid: (filters: ITrackStoreWeeklyGridFilters): Promise<ITrackStoreWeeklyGrid> =>
    axios.get(`${basePath}/weekly-grid${objectToQuery(filters)}`),
  getNotificationCollection: (
    filters: ITrackStoreNotificationCollectionFilters
  ): Promise<ITrackStoreNotificationCollection> => axios.get(`${basePath}/notifications${objectToQuery(filters)}`),
  getAllStoresCollection: (): Promise<ITrackStoreAllStoresCollection> => axios.get(`${basePath}/all-stores`),
  getOnDutyCollection: (filters: ITrackStoreOnDutyCollectionFilters): Promise<ITrackStoreOnDutyCollection> =>
    axios.get(`${basePath}/on-duty${objectToQuery(filters)}`),
  getLiveStoresCollection: (): Promise<ITrackStoreLiveStoresCollection> => axios.get(`${basePath}/live-stores`),
  getOrderCollection: (filters: ITrackStoreOrderCollectionFilters): Promise<ITrackStoreOrderCollection> =>
    axios.get(`${basePath}/orders${objectToQuery(filters)}`),
  getOrderDetails: ({ transactionId, ...filters }: ITrackStoreOrderDetailsFilters): Promise<ITrackStoreOrderDetails> =>
    axios.get(`${basePath}/orders/${transactionId}${objectToQuery(filters)}`),
};
